<template>
  <div class="producing-section container">
    <div class="producing-section__image-wrap">
      <img
        srcset="/static/images/producing@2x.png"
        src="/static/images/producing.png"
        class="producing-section__image"
      >
    </div>
    <div class="producing-section__content">
      <h4 class="producing-section__title">Sourcing and producing your products</h4>
      <div class="producing-section__description">We work with major factories around the world and throughout Europe and Asia to source the products you’re looking for or manufacturer the products you want to create.</div>

      <div class="producing-section__list">
        <ul class="producing-section__left-list">
          <li class="producing-section__list__item">Sourcing (finding existing products)</li>
          <li class="producing-section__list__item">Tooling</li>
        </ul>
        <ul class="producing-section__right-list">
          <li class="producing-section__list__item">Prototyping</li>
          <li class="producing-section__list__item">Mass production</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProducingSection',
}
</script>


<style lang="sass" scoped>
@import '~styles/shared'

.producing-section
  padding-top: 22px

  @include tablet
    padding-top: 38px
    display: flex
    flex-direction: row-reverse
    padding-left: 24px
    padding-right: 19px
    justify-content: center
    padding-bottom: 15px

  @include widescreen
    max-width: 1185px
    padding-top: 64px
    padding-bottom: 102px

.producing-section__image-wrap
  max-width: 292px
  margin-left: auto
  margin-right: auto

  @include tablet
    max-width: 50%
    margin-top: 6px
    flex-shrink: 0

  @include widescreen
    max-width: 561px
    padding-right: 17px
    margin-top: 31px

.producing-section__image
  width: 100%
  margin: 0 auto
  display: block

.producing-section__content
  margin-top: 36px

  @include tablet
    margin-top: 0

  @include widescreen
    margin-top: 68px

.producing-section__title
  font-size: 28px
  font-weight: 500
  line-height: 32px
  color: #1d3762
  letter-spacing: -.4px
  margin-bottom: 9px

  @include tablet
    font-size: 35px
    line-height: 40px
    letter-spacing: -.6px
    padding-bottom: 17px

  @include widescreen
    padding-right: 207px

.producing-section__description
  color: #525f7f
  padding-left: 3px
  letter-spacing: .1px
  margin-bottom: 18px

  @include tablet
    padding-left: 1px
    padding-right: 55px
    margin-bottom: 41px

  @include widescreen
    padding-right: 150px

.producing-section__list
  display: flex
  max-width: 500px
  flex-direction: column

  @include tablet
    flex-direction: row
    position: relative
    left: -2px

.producing-section__left-list
  margin-right: 23px

  @include tablet
    margin-right: 0
    width: 55%

  @include widescreen
    width: 50%

.producing-section__right-list
  @include tablet
    position: relative
    left: 4px
    width: 45%

  @include widescreen
    width: 50%

    .producing-section__list__item
      padding-right: 21px

.producing-section__list__item
  padding-left: 41px
  position: relative
  font-size: 17px
  font-weight: 500
  line-height: 25px
  margin-bottom: 24px
  letter-spacing: -.2px
  color: #525f7f

  &:before
    content: ''
    width: 26px
    height: 26px
    position: absolute
    left: 0
    background-image: url(/static/images/checkmark.png)
    background-size: 100%

</style>



// WEBPACK FOOTER //
// src/ProducingSection.vue